<template>
        <md-card>
            <md-card-header class="md-card-header-icon">
                <div class="flex items-center space-x-9" style="margin-top: -25px;">
                    <div class="tab-table-button cursor-pointer" :class="{'active': selectedType === 'contracts'}"
                         @click="selectTab('contracts')">
                        <font-awesome-icon class="md-icon m-0 mr-1" :icon="['fa', 'list-alt']"></font-awesome-icon>
                        <span class="text-base mx-2 mr-2.5">Contrats</span>
                        <span class="badge badge-default">{{ counts.contracts }}</span>
                    </div>
                    <div class="tab-table-button cursor-pointer" :class="{'active': selectedType === 'residuals'}"
                         @click="selectTab('residuals')">
                        <font-awesome-icon class="md-icon m-0 mr-1" :icon="['fa', 'trash']"></font-awesome-icon>
                        <span class="text-base mx-2 mr-2.5">Résidus</span>
                        <span class="badge badge-default">{{ counts.residuals }}</span>
                    </div>
                    <div class="tab-table-button cursor-pointer" :class="{'active': selectedType === 'oneTimes'}"
                         @click="selectTab('oneTimes')">
                        <font-awesome-icon class="md-icon m-0 mr-1" :icon="['fa', 'clock']"></font-awesome-icon>
                        <span class="text-base mx-2 mr-2.5">Ponctuels</span>
                        <span class="badge badge-default">{{ counts.oneTimes }}</span>
                    </div>
                </div>
                <div class="md-layout md-alignment-center-right" style="margin-top: -25px;">
                    <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                        <div class="flex items-center justify-end header-actions">
                            <div>
                                <md-button class="md-icon-button md-raised md-info" @mousedown="goToRoute($event, 'Add Intervention')">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                                    <span class="leading-none font-medium ml-2">Ajouter une intervention</span>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </md-card-header>
            <md-card-content class="pt-0">
                <management-table :filter="filter"
                                  :type="selectedType"
                                  :totalRows="counts[selectedType]"
                                  :selectedInterventions="selectedInterventions"
                                  :cartIsReady="cartIsReady"
                                  :cartStored="cartStored"
                                  @get-index-counts="getIndexCounts"
                                  @update-cart-interventions="$emit('update-cart-interventions', $event)"
                                  @updating="$emit('updating')"
                                  @loaded="tableLoaded"
                ></management-table>
            </md-card-content>
        </md-card>
</template>

<script>
import routerMixin from '@/mixins/router-mixin';
import ManagementTable from "./ManagementTable";

export default {
    name: "ManagementIndex",
    components: {
        ManagementTable
    },
    mixins: [routerMixin],
    props: {
        filter: Object,
        selectedInterventions: Array,
        cartIsReady: Boolean,
        cartStored: Number
    },
    data() {
        return {
            selectedType: 'contracts',
            counts: {
                contracts: 0,
                residuals: 0,
                oneTimes: 0,
            }
        }
    },
    methods: {
        async getIndexCounts() {
            this.$emit('updating')
            const { data } = await this.$store.dispatch('planningManagement/getIndexCounts', { filter: this.filter })
            this.counts = data
            this.$emit('loaded')
        },
        selectTab(type) {
            this.$emit('updating')
            this.selectedType = type
        },
        tableLoaded (e) {
            this.$emit('table-loaded', e)
        }
    },
    mounted() {
        if (this.$route.query.type) {
            this.selectedType = this.$route.query.type
        }
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                this.getIndexCounts()
            }
        },
        cartStored() {
            //If cart has been stored, refresh count
            this.getIndexCounts()
        }
    }
}
</script>

<style scoped lang="scss">
.tab-table-button {
    position: relative;
    margin: 0.3125rem 1px;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    outline: none;

    height: auto;
    width: auto;
    min-height: 40px !important;
    min-width: 185px !important;

    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    font-family: inherit;
    text-decoration: none;
    letter-spacing: 0;

    background: $gray-color;
    color: #ffffff;

    border: none;
    border-radius: 3px;

    white-space: nowrap;
    z-index: 5;
    will-change: box-shadow, transform;
    transition: all 150ms ease-in;
    -webkit-appearance: button;

    .md-icon {
        min-width: 18px;
        height: 18px;
        font-size: 18px !important;
    }

    .badge {
        background: #ffffff !important;
        color: $gray-color !important;

        font-size: .75rem;
        font-weight: 500;
        line-height: 1;
    }

    &.active {
        background: $brand-primary;
        &:hover {
            background: $brand-primary;
        }

        ::v-deep {
            .badge {
                color: $brand-primary !important;
            }
        }
    }

    &:hover {
        background: darken($gray-color, 10%);
    }
}
</style>
